import { Component, OnInit } from '@angular/core';
import {AnnualFeeInfoModel, CardExpiryInfoModel} from '../../dto/cardInfoModelBase';
import {InvoicesService} from '../services/invoices.service';
import {CardsService} from '../services/cards.service';

@Component({
  selector: 'app-next-card-expiries',
  templateUrl: './next-card-expiries.component.html',
  styleUrls: ['./next-card-expiries.component.css']
})
export class NextCardExpiriesComponent implements OnInit {
  public list: CardExpiryInfoModel[] = [];
  public isLoading = false;

  constructor(
    private cardsService: CardsService
  ) { }

  ngOnInit(): void {

    const start = 0;
    const count = 500;

    this.isLoading = true;
    this.cardsService.getNextCardExpiries(start, count).subscribe(list => {
      this.list = list;
      this.isLoading = false;
    });

  }


}
